/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Usernameplaceholder1Inputs */

const zh_profile_usernameplaceholder1 = /** @type {(inputs: Profile_Usernameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入用户名`)
};

const en_profile_usernameplaceholder1 = /** @type {(inputs: Profile_Usernameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your username`)
};

const es_profile_usernameplaceholder1 = /** @type {(inputs: Profile_Usernameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu nombre de usuario`)
};

/**
* | output |
* | --- |
* | "Enter your username" |
*
* @param {Profile_Usernameplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const profile_usernameplaceholder1 = /** @type {((inputs?: Profile_Usernameplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Usernameplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_profile_usernameplaceholder1(inputs)
	if (locale === "en") return en_profile_usernameplaceholder1(inputs)
	return es_profile_usernameplaceholder1(inputs)
});
export { profile_usernameplaceholder1 as "profile_usernamePlaceholder" }